/** tm/legal/settingsGuard.ts — 설정 모달의 「저장하지 않은 변경」 지킴이. 각 탭이 dirty 여부와 저장 함수를 알려 주면,
 *  모달은 탭 이동·닫기·뒤로 가기 전에 인라인 막대("저장하지 않은 변경이 있습니다 · 저장 / 버리기")를 띄운다 (확인 창 없음). */
import { useEffect, useRef } from 'react';

export interface SettingsGuard {
  /** 지금 탭의 변경 여부 + 저장 함수(성공하면 true) */
  report: (dirty: boolean, save: (() => Promise<boolean>) | null) => void;
  /** 변경이 있으면 막대를 띄우고, 없으면 바로 action */
  request: (action: () => void) => void;
}

/** 탭 안에서: dirty·save 가 바뀔 때마다 모달에 알린다 (사라질 때는 깨끗한 상태로) */
export function useGuardReport(guard: SettingsGuard | undefined, dirty: boolean, save: () => Promise<boolean>): void {
  const saveRef = useRef(save);
  saveRef.current = save;
  useEffect(() => { guard?.report(dirty, () => saveRef.current()); }, [guard, dirty]);
  useEffect(() => () => guard?.report(false, null), [guard]);
}
